


import React, { useState, useEffect } from "react";
import { getData, getOneData, postData } from "../components/helpers/Data";
import { Spinner } from "../components/helpers/Spinner";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";

const RestockingReport = () => {
  const [reportData, setReportData] = useState([]);

  var index = 0;

  useEffect(() => {
    setReportData([]);
    document.getElementById("spinner").style.display = "block";
    getData("fetch_restocking_report")
      .then((data) => {
        // return console.log(data);
        setReportData(data);
        document.getElementById("spinner").style.display = "none";
      })
      .catch((error) => console.log(error));
  }, []);

  const printPdf = (e) => {
    e.preventDefault();

    const tbl = document.getElementById("tableDiv").innerHTML;

    let title = "RESTOCKING REPORT";

    let j = `
  <div class="row">
  <br><br><br>
  <div class="row">
  <div class="col-md-4" style="font-size:25px;font-weight:bold;text-align:center;">${title}</div>
  <br>
  </div>
  <div>${tbl}</div>  
  </div>
  `;

    var val = htmlToPdfmake(j);
    var dd = {
      pageOrientation: "landscape",
      pageMargins: [40, 60, 40, 60],
      content: val,
      pageSize: "A4",
    };
    pdfMake.createPdf(dd).download();
  };
  return (
    <div>
      <div className=" ml-0">
        <h4 className="fs-title">RESTOCKING REPORT</h4>
      </div>
      <section id="rejection_rate" className="project-tab">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <button
                type="button"
                className="btn btn-sm btn-info col-2"
                onClick={printPdf}
              >
                Print
              </button>
              <ReactHTMLTableToExcel
                className="btn btn-sm btn-success col-2  ml-2"
                id="tbl_1"
                table="tbl1"
                filename="sales_report"
                sheet="sales report"
                buttonText="Export"
              />
            </div>
            <div className="row justify-content-center" id="tableDiv">
              <table
                className="table table-bordered table-sm table-stripped"
                id="tbl1"
                style={{ maxHeight: "500px" }}
              >
                <thead>
                  <tr>
                    <th>Index</th>
                    <th>Items</th>
                    <th>Quantity Stocked</th>
                    <th>Quantity Sold</th>
                    <th>Quantity Expired or Spoilt</th>
                    <th>Quantity Available</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.map((dt) => {
                    index++;
                    return (
                      <tr key={dt.id}>
                        <td>{index}</td>
                        <td>{dt.manufacturer_item}</td>
                        <td>{dt.quantity_stocked}</td>
                        <td>{dt.quantity_sold}</td>
                        <td>{dt.quantity_expired_or_spoilt}</td>
                        <td>{dt.max_quantity}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Spinner />
          </div>
        </div>
      </section>
    </div>
  );
};

export default RestockingReport